import React, {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import axios from "axios";

const DashboardDataContext = createContext();


export const DashboardDataProvider = ({ children }) => {
  const [analyticsMonthAndYear,setAnalyticsMonthAndYear] = useState({
    month: new Date().getMonth(),
    year: new Date().getFullYear()
  })//to store the date when we move through pages.
  const fetchData = async (url,token) => {
    try {
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Replace 'YOUR_ACCESS_TOKEN' with your actual access token
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response.status === 404) {
        return [];
      }
      console.error(`Error fetching data from ${url}:`, error);
      return null;
    }
  };

  const fetchMultipleApis = async (urls) => {
    const userDetails = JSON.parse(localStorage.getItem("token"));
    let token = userDetails ? userDetails.result.token : null;
    const promises = urls.map((url) => fetchData(url, token));
    return Promise.all(promises);
  };

  const [apiData, setApiData] = useState(null);
  useEffect(() => {
  }, [apiData]);

  const dataFetch = async (searchQuery) => {
    const fetchDataAndStore = async () => {
      const startYear = searchQuery.startYear ?? searchQuery.year;
      const endYear = searchQuery.endYear ?? searchQuery.year;
      const startMonth = searchQuery.startMonth !== undefined ? searchQuery.startMonth + 1 : searchQuery.month + 1;
      const endMonth = searchQuery.endMonth !== undefined ? searchQuery.endMonth + 1 : searchQuery.month + 1;

      const apiUrls = [
        `${process.env.REACT_APP_SERVER_BASE_URL}/monthlyreports/daterange-search?startyear=${startYear}&endyear=${endYear}&startingmonth=${startMonth}&endingmonth=${endMonth}`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/productreports/search?startyear=${startYear}&endyear=${endYear}&startingmonth=${startMonth}&endingmonth=${endMonth}`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/transactionreports/rep/search?name=all&actual=true&startyear=${startYear}&endyear=${endYear}&startingmonth=${startMonth}&endingmonth=${endMonth}`,
        `${process.env.REACT_APP_SERVER_BASE_URL}/transactionreports/doctor/search?name=all&actual=true&startyear=${startYear}&endyear=${endYear}&startingmonth=${startMonth}&endingmonth=${endMonth}`,
      ];

      try {
        const data = await fetchMultipleApis(apiUrls);
        const newData = {};
        apiUrls.forEach((url, index) => {
          newData[index] = data[index] ? data[index] : [];
        });
        setApiData(newData);
        // localStorage.setItem('monthData',JSON.stringify(newData))
      } catch (error) {
        console.error("Error fetching data from APIs:", error);
      }
    };
    fetchDataAndStore();
  };
  return (
    <DashboardDataContext.Provider value={{ apiData, dataFetch, setApiData,analyticsMonthAndYear,setAnalyticsMonthAndYear }}>
      {children}
    </DashboardDataContext.Provider>
  );
};

export const useDashboardDataContext = () => {
  return useContext(DashboardDataContext);
};
